export const sizes = {
  full: '100%',
  calendarDayMinHeight: '92px',
  calendarDayNumber: '22px',
  calendarTodayRingWidth: '2px',
  textEllipsisMax: '24rem',
  modalContentMinWidth: '320px',
  loadingSpinnerSm: '3rem',
  sidebarLogo: '3rem',
} as const;
